/**
 * @generated SignedSource<<faadc0bd00cc164705678c582078744e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rawDocumentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "rawDocumentId",
        "variableName": "rawDocumentId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteRawDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteRawDocumentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteRawDocumentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "057ce66274265eae188108a573c5e9a3",
    "id": null,
    "metadata": {},
    "name": "DeleteRawDocumentMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteRawDocumentMutation(\n  $rawDocumentId: ID!\n) {\n  deleteRawDocument(rawDocumentId: $rawDocumentId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "506a909b0ed4a23bde8eb9c477773edb";

export default node;
